import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import PersonIcon from "@material-ui/icons/Person";
import Pagination from "components/Pagination";
import SearchBar from "components/SearchBar";
import Switch from "@material-ui/core/Switch";
import Tooltip from "@material-ui/core/Tooltip";
import EventNoteIcon from "@material-ui/icons/EventNote";
import {
  Wrapper,
  Header,
  SearchWrapper,
  UserEmail,
  SwitchWrapper,
  Filters,
} from "styles/pages/admin-users";

const UsersTable = ({
  users,
  take,
  currentPage,
  setCurrentPage,
  setSelectedUser,
  selectedUser,
  searchUser,
  fetchAllUser,
  updateUserStatus,
  loginToUser,
  getAllUsers,
  setUserAutomation,
  userAutomation,
  pendingUser,
  setPendingUser,
}) => (
  <TableContainer component={Paper}>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>
            <Wrapper>
              <Header>
                <h2>Users ({users?.userCounts?.TotalUsers})</h2>
                <SearchWrapper>
                  <SearchBar
                    searchById={(v) => searchUser(v)}
                    fetchAllOrders={fetchAllUser}
                  />
                </SearchWrapper>
                <EventNoteIcon
                  onClick={getAllUsers}
                  style={{
                    color: "#1c84c6",
                    cursor: "pointer",
                    marginLeft: 20,
                    color: "green",
                  }}
                />
              </Header>

              <Filters>
                <p onClick={getAllUsers}>All Users</p>
                <p onClick={() => setUserAutomation(!userAutomation)}>
                  Auto Users
                </p>
                <p onClick={() => setPendingUser(!pendingUser)}>
                  Pending Users
                </p>
              </Filters>
            </Wrapper>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {!!users?.users?.length ? (
          users?.users.map((user) => (
            <TableRow key={user?.User}>
              <TableCell
                component="th"
                scope="row"
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  background:
                    selectedUser && user && selectedUser?.User === user?.User
                      ? "#000"
                      : "inherit",
                  color:
                    selectedUser && user && selectedUser?.User === user?.User
                      ? "#fff"
                      : "#888888",
                }}
              >
                {user?.User ? (
                  <>
                    <UserEmail onClick={() => setSelectedUser(user)}>
                      <PersonIcon />
                      <div>
                        <p>{user?.User}</p>
                        <p>{user?.UserData?.User?.FullName}</p>
                      </div>
                    </UserEmail>
                    <SwitchWrapper>
                      <Tooltip
                        arrow={true}
                        title={user?.UserData?.Status}
                        placement="bottom"
                      >
                        <Switch
                          color="primary"
                          checked={
                            user?.UserData?.Status === "Active" ? true : false
                          }
                          onChange={(e, value) => {
                            const payload = {
                              user: user?.User,
                              status: value ? "Active" : "In-Active",
                            };
                            updateUserStatus(payload);
                          }}
                        />
                      </Tooltip>
                    </SwitchWrapper>
                    <div onClick={() => loginToUser(user)}>Impersonate</div>
                  </>
                ) : null}
              </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell>
              <h3>No user found</h3>
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
    {users?.userCounts?.TotalUsers > 1 && (
      <div style={{ margin: 10 }}>
        <Pagination
          totalCount={users?.userCounts?.TotalUsers}
          take={take}
          page={currentPage}
          showFirstButton={false}
          showLastButton={false}
          hidePrevButton={true}
          hideNextButton={true}
          onChange={(e, v) => setCurrentPage(v)}
        />
      </div>
    )}
  </TableContainer>
);

export default UsersTable;
